function calculateDistance(location1, location2lat, location2lng) {
  var R = 6371.0710; // Radius of the Earth in miles
  var rlat1 = location1.lat() * (Math.PI/180); // Convert degrees to radians
  var rlat2 = location2lat * (Math.PI/180); // Convert degrees to radians
  var difflat = rlat2-rlat1; // Radian difference (latitudes)
  var difflon = (location2lng - location1.lng()) * (Math.PI/180); // Radian difference (longitudes)

  var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
  return d;
}

function initialize(data) {
  // Setup map and options
  var mapCenter = new google.maps.LatLng(51.139696269927214, 10.209120109643962);
  var map = new google.maps.Map(document.getElementById("store-locator-map"), {
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    mapId: "ef920c65eaf15928",
    center: mapCenter,
    zoom: 6
  });

  let activeMarkers = [];
  let openMarker = null;
  let referenceLocation;

  // Add listeners to form
  const submitSearchBtn = document.querySelector(".StoreLocatorForm__SubmitBtn");

  submitSearchBtn.addEventListener("click", function() {
    handleSearch(data);
  })

  // Initialize search
  const searchInput = document.getElementById('address-input');
  const autocomplete = new google.maps.places.Autocomplete(searchInput);

  autocomplete.addListener('place_changed', () => {
    referenceLocation = autocomplete.getPlace();
  });

  function handleSearch(data) {
    while (activeMarkers.length > 0) {
      const marker = activeMarkers.pop();
      marker.map = null;
    }

    const distance = parseFloat(document.querySelector("#distance").value);
    const searchTerms = document.querySelector("#search_terms").value;
    const categories = [];

    document.querySelectorAll("[name='category']").forEach(input => {
      if(input.checked) {
        categories.push(input.value);
      }
    })
    
    const addressQuery = (searchInput.value || "").trim();

    if (referenceLocation?.geometry) {
      // Visitor picked an address from the autocomplete suggestions.
      runRadiusSearch(referenceLocation, distance, categories, data);
    } else if (addressQuery) {
      // Visitor typed a postal code / address but didn't pick a suggestion.
      // Geocode the raw input so the search still works (don't force a pick).
      new google.maps.Geocoder().geocode(
        { address: addressQuery, componentRestrictions: { country: "de" }, region: "DE" },
        function (results, status) {
          if (status === "OK" && results && results[0]) {
            runRadiusSearch({ geometry: results[0].geometry }, distance, categories, data);
          } else if (searchTerms) {
            runNameSearch(searchTerms, categories, data);
          } else {
            alert("Keine Treffer für: " + addressQuery + ". Bitte Postleitzahl oder Adresse prüfen.");
          }
        }
      );
    } else if (searchTerms) {
      // Only the "Suche nach Fachhändler" field was used.
      runNameSearch(searchTerms, categories, data);
    } else {
      alert("Bitte geben Sie eine Postleitzahl, Adresse oder einen Händlernamen ein.");
    }
  };

  // Largest radius offered in the "Umkreis" dropdown (e.g. 50 km).
  function getMaxDistance() {
    var opts = [].slice.call(document.querySelectorAll("#distance option"))
      .map(function (o) { return parseFloat(o.value); })
      .filter(function (n) { return !isNaN(n); });
    return opts.length ? Math.max.apply(null, opts) : 50;
  }

  // Show a guidance line above the result cards (cleared on the next search,
  // since locateStores/locateStoresByName reset the results container).
  function setResultsMessage(text) {
    var container = document.querySelector(".StoreLocatorResults__Container");
    if (!container) return;
    var msg = document.createElement("div");
    msg.className = "StoreLocatorResults__Message";
    msg.textContent = text;
    msg.style.padding = "12px 0";
    msg.style.fontWeight = "600";
    // The results container is a 3-column layout; span the message across all
    // columns so the sentence isn't split into pieces with gaps between them.
    msg.style.width = "100%";
    msg.style.columnSpan = "all";
    msg.style.webkitColumnSpan = "all";
    container.insertBefore(msg, container.firstChild);
  }

  // Radius search with empty-result guidance: ask the visitor to widen the
  // radius, or — when already at the maximum radius — apologise and list every
  // available dealer (nearest first) so the search never dead-ends.
  function runRadiusSearch(referenceLocation, distance, categories, data) {
    var count = locateStores(referenceLocation, distance, categories, data, false);
    if (count === 0) {
      var maxDistance = getMaxDistance();
      if (distance < maxDistance) {
        setResultsMessage("Im Umkreis von " + distance + " km haben wir keinen Händler gefunden. Bitte vergrößern Sie den Suchradius.");
      } else {
        var total = locateStores(referenceLocation, distance, categories, data, true);
        if (total > 0) {
          setResultsMessage("Es tut uns leid – in Ihrer unmittelbaren Nähe ist derzeit kein Händler verfügbar. Hier sehen Sie alle verfügbaren Händler, nach Entfernung sortiert:");
        } else {
          setResultsMessage("Für die gewählte Produktauswahl wurde leider kein Händler gefunden. Bitte passen Sie Ihre Auswahl an.");
        }
      }
    }
    updateMapBounds(map);
  }

  function runNameSearch(searchTerms, categories, data) {
    var count = locateStoresByName(searchTerms, categories, data);
    if (count === 0) {
      setResultsMessage("Kein Händler mit dem Namen „" + searchTerms + "“ gefunden. Bitte prüfen Sie die Schreibweise.");
    }
    updateMapBounds(map);
  }

  function updateMapBounds(map) {
    const bounds = new google.maps.LatLngBounds();
    
    activeMarkers.forEach((marker) => {
      bounds.extend(marker.position);
    });

    if (!bounds.isEmpty()) {
      map.fitBounds(bounds);
    }
  }

  function displayMarker(data, locationLat, locationLng, index) {    
    var markerLocation = new google.maps.LatLng(locationLat, locationLng); // set position
    
    var newMarker = new google.maps.marker.AdvancedMarkerElement({
      position: markerLocation,
      map: map,
    });

    var infoContent = `
      <div class="StoreLocatorResultMarker">
        <strong class="StoreLocatorResultMarker__Name">${data.name}</strong><br>

        <div class="StoreLocatorResultMarker__Address">
          ${data.street}<br>
          ${data.zip} ${data.city}<br>
          Deutschland
        </div>

        <div class="StoreLocatorResultMarker__Contact">
          ${data.phone ? "<span>Tel: " + data.phone + "</span><br>" : ""}
        </div>
      </div>
    `;

    // Add info window
    newMarker.info = new google.maps.InfoWindow({
      content: infoContent
    });

    activeMarkers.push(newMarker);

    // Add listener for info window and close the other markers
    google.maps.event.addListener(newMarker, 'click', function () {
      // console.log("going to marker " + newMarker);
      if(openMarker) {
        openMarker.info.close();
      }

      openMarker = newMarker;
      openMarker.info.open(map, newMarker);

      const storeCard = document.getElementById("store-" + index);

      storeCard.scrollIntoView();
    });
  }

  function locateStores(referenceLocation, distance, categories, data, ignoreDistance) {
    const storeCardsSection = document.querySelector(".StoreLocatorResults__Container");
    const referenceLocationAddress = referenceLocation.geometry.location;

    // Remove all cards with results
    storeCardsSection.innerHTML = "";

    // Collect dealers matching the selected categories (and within the radius,
    // unless ignoreDistance is set), then render them nearest-first.
    const matches = [];

    data.forEach((location, index) => {
      let shouldRender = false;
      if (categories.length) {
        categories.forEach(category => {
          if (location[category]) {
            shouldRender = true;
          }
        });
      } else {
        shouldRender = true;
      }
      if (!shouldRender) return;

      const distanceToReference = calculateDistance(referenceLocationAddress, location.lat, location.lng);
      if (ignoreDistance || distanceToReference < distance) {
        matches.push({ location: location, index: index, distanceToReference: distanceToReference });
      }
    });

    matches.sort((a, b) => a.distanceToReference - b.distanceToReference);

    matches.forEach(match => {
      const location = match.location;
      const index = match.index;

      displayMarker(location, location.lat, location.lng, index);

      const cardElement = document.createElement("div");
      cardElement.classList.add("StoreLocatorResultCard");
      cardElement.setAttribute("id", "store-" + index);
      cardElement.innerHTML = resultCardTemplate(location, match.distanceToReference, index);

      const locateBtn = cardElement.querySelector("button[data-action='Locate marker']");
      if (locateBtn) {
        locateBtn.addEventListener("click", function() { locateMarker(location, map); });
      }

      const directionsBtn = cardElement.querySelector("button[data-action='Show directions']");
      if (directionsBtn) {
        directionsBtn.addEventListener("click", function() { showDirections(referenceLocationAddress, location); });
      }

      storeCardsSection.appendChild(cardElement);
    });

    return matches.length;
  }

  function locateStoresByName(searchTerms, categories, data) {
    const storeCardsSection = document.querySelector(".StoreLocatorResults__Container");

    // Remove all cards with results
    storeCardsSection.innerHTML = "";

    let rendered = 0;

    data.forEach((location, index) => {
      let locationLat = location.lat;
      let locationLng = location.lng;

      // Check if the categories are correct
      let shouldRender = false;

      if(categories.length) {
        categories.forEach(category => {
          if(location[category]) {
            shouldRender = true;
          }
        });
      } else {
        shouldRender = true;
      }

      if(shouldRender && !location.name.toLowerCase().includes(searchTerms.toLowerCase())) {
        shouldRender = false;
      }

      if(shouldRender) {
        displayMarker(location, locationLat, locationLng, index);

        const cardElement = document.createElement("div");
        cardElement.classList.add("StoreLocatorResultCard");
        cardElement.setAttribute("id", "store-" + index);
        cardElement.innerHTML = resultCardTemplate(location, null, index);

        const locateBtn = cardElement.querySelector("button[data-action='Locate marker']");
        if (locateBtn) {
          locateBtn.addEventListener("click", function() { locateMarker(location, map); });
        }

        storeCardsSection.appendChild(cardElement);
        rendered++;
      }
    });

    return rendered;
  }

  function showDirections(referenceLocation, location) {
    console.log("Showing directions");
    let directionsService = new google.maps.DirectionsService();
    let locationLatLng = new google.maps.LatLng(location.lat, location.lng);

    const directionsRequest = {
      origin: referenceLocation,
      destination: locationLatLng,
      travelMode: 'DRIVING'
    }

    directionsService.route(directionsRequest, function(result, status) {
      if(status == 'OK') {
        console.log("result", result);

        renderRoute(result);
      }
    })
  }

  function renderRoute(result) {
    let popupHeader = document.querySelector(".StoreLocatorPopup__Header");
    let popupInstructions = document.querySelector(".StoreLocatorPopup__Instructions");
    let firstAvailableRouteSteps = result.routes[0].legs[0];

    popupHeader.querySelector("[data-info='from']").innerText = firstAvailableRouteSteps.start_address;
    popupHeader.querySelector("[data-info='to']").innerText = firstAvailableRouteSteps.end_address;
    popupHeader.querySelector("[data-info='distance']").innerText = firstAvailableRouteSteps.distance.text;
    popupHeader.querySelector("[data-info='duration']").innerText = firstAvailableRouteSteps.duration.text;

    let html = "<ol>";

    firstAvailableRouteSteps.steps.forEach(step => {
      html += "<li>" + step.instructions + "</li>";
    });

    html += "</ol>";

    popupInstructions.innerHTML = html;

    // Open popup
    popup.open();
  }
  
  function locateMarker(data, map) {
    console.log("Locating marker");
    const latLng = new google.maps.LatLng(data.lat, data.lng);

    map.setCenter(latLng);
    map.setZoom(16);

    console.log(activeMarkers)
  }

  const resultCardTemplate = (data, distance, index) => {
    return `
      <h3 class="StoreLocatorResultCard__Name">${data.name}</h3>

      <div class="StoreLocatorResultCard__Categories">
        ${data.opt1 ? "<span>Luftreiniger</span>" : ""}
        ${data.opt2 ? "<span>Elektrische Stapelschneider</span>" : ""}
        ${data.opt3 ? "<span>Aktenvernichter & kleine Büro-Schneidegeräte</span>" : ""}
      </div>

      <div class="StoreLocatorResultCard__Address">
        ${data.street}<br>
        ${data.zip} ${data.city}<br>
        Deutschland
      </div>

      <div class="StoreLocatorResultCard__Contact">
        ${data.phone ? "<a href='tel:" + data.phone + "'>Tel: " + data.phone + "</a><br>" : ""}
        ${data.email ? "<a href='mailto:" + data.email + "'>E-Mail: " + data.email + "</a><br>" : ""}
        ${data.url ? "<a target='_blank' href='" + data.url + "'>" + data.url + "</a>" : ""}
      </div>

      ${distance ? "<div class='StoreLocatorResultCard__Distance'>Entfernung " + distance.toFixed(2) + "km</div>" : ""}


      <div class="StoreLocatorResultCard__Actions">
        <button data-action="Locate marker" class="StoreLocatorResultCard__Actions--locate">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
            <path fill="none" stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
          </svg>

          Karte
        </button>

        ${distance ? "<button class='icon' data-action='Show directions' class='StoreLocatorResultCard__Actions--directions'><svg version='1.1' id='_x32_' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 512 512'  xml:space='preserve'><g><polygon class='st0' points='256.003,0 18.618,316.508 153.601,316.508 153.601,512 358.4,512 358.4,316.508 493.382,316.508 	'/></g></svg> Route</button>" : ""}
      </div>
    `;
  };

  const popupEl = document.querySelector(".StoreLocator__Popup");
  const overlayEl = document.querySelector(".StoreLocator__PopupOverlay");
  const closePopupEl = document.querySelector(".StoreLocator__Popup--close");

  const popup = {
    open: () => {
      popupEl.classList.add("active");
      overlayEl.classList.add("active");
    },
    close: () => {
      popupEl.classList.remove("active");
      overlayEl.classList.remove("active");
    }
  }

  overlayEl.addEventListener("click", function() {
    popup.close();
  });

  closePopupEl.addEventListener("click", function() {
    popup.close();
  });
}

$(document).ready(function () {
  function getStoresData() {
    const url = window.theme.dealerListUrl;

    fetch(url)
      .then(response => {
        if (!response.ok) {
          getStoresData();
          
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then(jsonData => {
        responseData = jsonData;

        initialize(responseData); // init map
      })
      .catch(error => {
        console.error("There was a problem with the fetch operation:", error);
      });
  }

  getStoresData();

  // const data = [
  //   {
  //     "name": "Feistauer Bürosystemhaus GmbH",
  //     "address": "Chausseestr. 9 a \n16515 Oranienburg \nDeutschland",
  //     "lat": "52.7676355",
  //     "lng": "13.2457803",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "1",
  //     "Elektrische Stapelschneider": "1",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": "1"
  //   },
  //   {
  //     "name": "ABE - Minuth GmbH Allgemeine Büroeinrichtungen",
  //     "address": "Kaiser-Friedrich-Str. 7\n10585 Berlin\nDeutschland",
  //     "lat": "52.5168306",
  //     "lng": "13.3002877",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "1",
  //     "Elektrische Stapelschneider": "",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": ""
  //   },
  //   {
  //     "name": "Roy Schulz GmbH",
  //     "address": "Nunsdorfer Ring 16\n12277 Berlin\nDeutschland",
  //     "lat": "52.4069476",
  //     "lng": "13.3820193",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "1",
  //     "Elektrische Stapelschneider": "",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": ""
  //   },
  //   {
  //     "name": "BüroExpress GmbH",
  //     "address": "Kurfürstenstraße 31\n14467 Potsdam\nDeutschland",
  //     "lat": "52.40470149999999",
  //     "lng": " 13.066071",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "",
  //     "Elektrische Stapelschneider": "1",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": ""
  //   },
  //   {
  //     "name": "EHRIG GmbH Büro-Systemhaus",
  //     "address": "Sophie-Charlotten-Str. 92\n14059 Berlin\nDeutschland",
  //     "lat": "52.51609029999999",
  //     "lng": "13.2888305",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "",
  //     "Elektrische Stapelschneider": "1",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": ""
  //   },
  //   {
  //     "name": "advo-discount GmbH GSG Gewerbehof",
  //     "address": "Plauener Str. 163-165\n13053 Berlin\nDeutschland",
  //     "lat": "52.5453232",
  //     "lng": "13.5136355",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "",
  //     "Elektrische Stapelschneider": "",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": "1"
  //   },
  //   {
  //     "name": "Peter Hussock Büromaschinenservice",
  //     "address": "Seebadallee 12\n15834 Rangsdorf\nDeutschland",
  //     "lat": "52.2912542",
  //     "lng": "13.4263851",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "",
  //     "Elektrische Stapelschneider": "",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": "1"
  //   },
  //   {
  //     "name": "Detlef Hornung - Bürotechnik",
  //     "address": "Barstr. 31\n10713 Berlin \nDeutschland",
  //     "lat": "52.4811507",
  //     "lng": "13.3130678",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "1",
  //     "Elektrische Stapelschneider": "1",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": ""
  //   },
  //   {
  //     "name": "Bürokom Gesellschaft für Büro- u. Objektausstattung mbH",
  //     "address": "Neuendorfstr. 26\n 16761 Hennigsdorf \nDeutschland",
  //     "lat": "52.63461059999999",
  //     "lng": "13.2072364",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "1",
  //     "Elektrische Stapelschneider": "1",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": ""
  //   },
  //   {
  //     "name": "Detlef Hornung - Bürotechnik",
  //     "address": "Barstr. 31\n10713 Berlin \nDeutschland",
  //     "lat": "52.4811507",
  //     "lng": "13.3130678",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "",
  //     "Elektrische Stapelschneider": "1",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": "1"
  //   },
  //   {
  //     "name": "Feistauer Bürosystemhaus GmbH",
  //     "address": "Chausseestr. 9 a\n16515 Oranienburg\nDeutschland",
  //     "lat": "52.7676355",
  //     "lng": "13.2457803",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "",
  //     "Elektrische Stapelschneider": "1",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": "1"
  //   },
  //   {
  //     "name": "Voigtländer Büromaschinen",
  //     "address": "Blissestraße 51\n 10713 Berlin \nDeutschland",
  //     "lat": "52.4803773",
  //     "lng": " 13.320722",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "1",
  //     "Elektrische Stapelschneider": "",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": "1"
  //   },
  //   {
  //     "name": "Büro & Werbewelten Inh. Martin Lindow",
  //     "address": "Kleiststr. 78\n 14624 Dallgow-Döberitz \nDeutschland",
  //     "lat": "52.549642",
  //     "lng": "13.0687586",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "1",
  //     "Elektrische Stapelschneider": "",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": "1"
  //   },
  //   {
  //     "name": "ZIB Informations- und Bürosysteme Service GmbH",
  //     "address": "Karl-Marx-Str. 114\n 15745 Wildau \nDeutschland",
  //     "lat": "52.3201252",
  //     "lng": "13.6354594",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "1",
  //     "Elektrische Stapelschneider": "1",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": "1"
  //   },
  //   {
  //     "name": "Thörner für's Büro GmbH Bürobedarf-Großvertrieb",
  //     "address": "Salzburger Str. >\n 10825 Berlin \nDeutschland",
  //     "lat": "52.4869823",
  //     "lng": "13.3422175",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "1",
  //     "Elektrische Stapelschneider": "1",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": "1"
  //   },
  //   {
  //     "name": "Bürowelt Bender GmbH",
  //     "address": "Kurmarkstr. 1\n 14624 Dallgow-Döberitz \nDeutschland",
  //     "lat": "52.53918969999999",
  //     "lng": "13.0587637",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "1",
  //     "Elektrische Stapelschneider": "",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": ""
  //   },
  //   {
  //     "name": "Schwendy GmbH Schreib- und Spielwaren",
  //     "address": "Berliner Str. 29\n 15806 Zossen \nDeutschland",
  //     "lat": "52.2154389",
  //     "lng": "13.4481701",
  //     "telephone": "+49 3301 3248",
  //     "email": "Systemhaus@feistauer-gmbh.de",
  //     "website": "http://www.feistauer-gmbh.de/",
  //     "Luftreiniger": "1",
  //     "Elektrische Stapelschneider": "",
  //     "Aktenvernichter & kleine Büro-Schneidegeräte": ""
  //   }
  // ]

  // initialize(data);
});